export default {
  // Navigation
  nav_home: 'Home',
  nav_about: 'About Us',
  nav_services: 'Services',
  nav_catalog: 'Supplies',
  nav_contact: 'Contact',
  nav_quote: 'Get a Quote 24/7',
  nav_menu: 'Menu',
  nav_close: 'Close',
  nav_map: 'Map',
  nav_testimonials: 'Testimonials',

  // Hero
  hero_headline: 'World-Class Naval Supply',
  hero_subheadline: 'Since 1975, we operate 24/7 across Mexico\'s 13 strategic ports. Integrated supply, on-time delivery, and frictionless logistics for international fleets.',
  hero_cta_primary: 'Request a Quote',
  hero_cta_secondary: 'View Services',
  hero_stat_years: '50+',
  hero_stat_years_label: 'Years of Experience',
  hero_stat_ports: '13',
  hero_stat_ports_label: 'Ports Covered',
  hero_stat_247: '24/7',
  hero_stat_247_label: 'Operational Availability',
  hero_scroll: 'Discover our solutions',
  hero_coverage_title: 'National Coverage',
  hero_coverage_subtitle: '13 strategic ports across Mexico',

  // About
  about_tag: 'About Us',
  about_headline: '50 years of experience operating Mexico\'s ports',
  about_body_1: 'Founded in 1975, Avimar Ship Chandlers emerged in response to the growing demand for naval supply in the port of Coatzacoalcos. Today, five decades later, we are a multimodal company with operational presence across the country\'s 13 strategic ports: from the Pacific to the Gulf of Mexico.',
  about_body_2: 'Our evolution has not been linear. We have transitioned from basic ship supply to integrated port solutions including lanchaje, warehousing, waste management, and consignee representation.',
  about_body_3: 'We operate refrigerated vehicles, own cranes, and employ highly qualified personnel. We do not outsource: we control the supply chain from start to finish.',
  about_cta: 'Learn Our History',
  about_stat_years: 'Years of Track Record',
  about_stat_years_desc: 'Since 1975, without interruption',
  about_stat_ports: 'Ports in Operation',
  about_stat_ports_desc: 'Complete national coverage',
  about_stat_247: 'Total Availability',
  about_stat_247_desc: 'Any schedule, any day',
  about_hq_label: 'Headquarters',
  about_hq_location: 'Coatzacoalcos, Veracruz',
  about_hq_caption: 'Logistics operations center with owned fleet',

  // Services
  services_tag: 'Multimodal Services',
  services_headline: 'Integrated port solutions for any operational scale',
  services_subheadline: 'From single vessel provisioning to full fleet logistics. Every service is designed to reduce port time and maximize operational efficiency.',
  services_cta: 'View Services',
  service_avituallamiento: 'Ship Supply',
  service_avituallamiento_desc: 'Supply of provisions, cabin consumables, and deck items with direct onboard delivery. Owned refrigerated fleet for guaranteed cold chain.',
  service_lanchaje: 'Lanchaje',
  service_lanchaje_desc: 'Transport of personnel, crew, and cargo between vessels and port using fast and safe boats.',
  service_reparaciones: 'Naval Repairs',
  service_reparaciones_desc: 'Ship repair and maintenance services in port. Qualified technical team for rapid interventions.',
  service_almacenamiento: 'Warehousing',
  service_almacenamiento_desc: 'Port warehouses with temperature control and security for cargo storage before shipment.',
  service_residuos: 'Waste Collection',
  service_residuos_desc: 'Integrated management of ship garbage and waste in compliance with MARPOL regulations.',
  service_agencia: 'Consignee Agency',
  service_agencia_desc: 'Official vessel representation before port, customs, and immigration authorities.',
  services_highlight_delivery: 'Direct onboard delivery',
  services_highlight_cold: 'Guaranteed cold chain',
  services_highlight_stock: 'Emergency stock 24/7',
  services_highlight_crew: 'Crew transport',
  services_highlight_docs: 'Light cargo and documents',
  services_highlight_weather: 'Operation under any weather',
  services_highlight_maintenance: 'Preventive maintenance',
  services_highlight_urgent: 'Urgent repairs',
  services_highlight_certified: 'Certified technical staff',
  services_highlight_temp: 'Temperature control',
  services_highlight_digital: 'Digitalized inventory',
  services_highlight_security: 'Security 24/7',
  services_highlight_marpol: 'MARPOL compliance',
  services_highlight_docs_port: 'Port documentation',
  services_highlight_scheduled: 'Scheduled collection',
  services_highlight_clearance: 'Port clearance procedures',
  services_highlight_dispatch: 'Crew dispatch',
  services_highlight_permits: 'Permits and departure',

  // Supplies
  supplies_tag: 'Naval Chandlering',
  supplies_headline: 'Certified nautical supplies for your fleet operation',
  supplies_intro: 'As a ship chandler with 50 years of experience, we do not distribute generic supplies. Every item in our catalog is selected specifically for onboard operations: from fresh provisions for the crew to life-saving equipment certified under IMO regulations. We audit every supplier, verify batches before shipment, and maintain a documented cold chain from door to onboard.',
  supplies_cta: 'Explore Chandler Catalog',
  supplies_category_provisiones: 'Onboard Provisions',
  supplies_category_provisiones_desc: 'Red meats, American cuts, cold cuts, fresh fish, fruits and vegetables, frozen goods, beverages, groceries, and personal items for crew. Direct onboard delivery with refrigerated fleet.',
  supplies_category_consumibles: 'Cabin & Bridge Consumables',
  supplies_category_consumibles_desc: 'Kitchen and bar utensils, office supplies, onboard medical equipment, cleaning supplies, white goods, personal hygiene, and cabin hardware for crew comfort.',
  supplies_category_cubierta: 'Deck, Machinery & Safety',
  supplies_category_cubierta_desc: 'Marine ropes, cargo and stowage equipment, industrial hoses, marine lubricants, hand tools, piping, valves, bearings, welding equipment, and electrical material for onboard maintenance.',
  supplies_category_cartas: 'Nautical Charts & IMO Publications',
  supplies_category_cartas_desc: 'British, USCG, Japanese, Australian, and Canadian charts. Notices to mariners, tide tables, signal lists, and mandatory navigation publications for compliance.',
  supplies_category_salvamento: 'IMO Life-Saving Equipment',
  supplies_category_salvamento_desc: 'Emergency rations, whistles, radar reflectors, reflective tape, certified life jackets, first aid kits, life rings, extinguishers, and certified fire hoses.',
  supplies_category_pirotecnia: 'Emergency Pyrotechnics',
  supplies_category_pirotecnia_desc: 'Parachute signals, smoke flares, hand flares, man overboard signals, line throwers, and automatic buoys with smoke and light signals conforming to SOLAS regulation.',
  supplies_tag_fresh: 'Fresh',
  supplies_tag_cabin: 'Cabin',
  supplies_tag_deck: 'Deck',
  supplies_tag_navigational: 'Navigational',
  supplies_tag_safety: 'Safety',
  supplies_tag_emergency: 'Emergency',

  // Testimonials
  testimonials_tag: 'Clients & Partners',
  testimonials_headline: 'International shipping companies that trust our operation',
  testimonials_subheadline: 'Our clients\' trust is not requested: it is built with every on-time delivery.',
  testimonials_quote_1: 'At Avimar we found what the competition does not offer: response in under 2 hours and exact delivery as requested. We have been working with them for 8 years in Coatzacoalcos and Veracruz.',
  testimonials_author_1: 'Capt. James Morrison',
  testimonials_role_1: 'Operations Manager',
  testimonials_company_1: 'Pacific Maritime Services Ltd.',
  testimonials_quote_2: 'Their lanchaje capability in adverse conditions saved a critical dispatch. They are not a supplier: they are an operational ally in every Mexican port where we dock.',
  testimonials_author_2: 'Elena Vásquez',
  testimonials_role_2: 'Purchasing Director',
  testimonials_company_2: 'TransOceanic Logistics Group',
  testimonials_quote_3: 'The quality control of their provisions is rigorous. We have never had a return due to damaged product. Their cold chain is impeccable.',
  testimonials_author_3: 'Michael Chen',
  testimonials_role_3: 'Fleet Superintendent',
  testimonials_company_3: 'Global Seaways Corporation',
  testimonials_quote_4: 'Since we started using their consignee agency service, we reduced port clearance times by 40%.',
  testimonials_author_4: 'Ana Lucía Herrera',
  testimonials_role_4: 'Consignee Agent',
  testimonials_company_4: 'Marina del Norte S.A.',
  testimonials_quote_5: 'Waste collection with complete MARPOL documentation gives us peace of mind with authorities. Their regulatory compliance is exemplary.',
  testimonials_author_5: 'Robert K. Andersen',
  testimonials_role_5: 'Environmental Compliance Officer',
  testimonials_company_5: 'Nordic Shipping Alliance',
  testimonials_quote_6: 'Their stock of nautical charts and publications is the most complete we have found in Mexico. They always have the latest edition available.',
  testimonials_author_6: 'Francisco Delgado',
  testimonials_role_6: 'Navigation Officer',
  testimonials_company_6: 'Ibero-American Shipping Co.',

  // CTA
  cta_available_now: 'Available Now',
  cta_trust_247: '24/7 Operation',
  cta_trust_iso: 'ISO Standards',
  cta_trust_response: 'Response < 1h',
  cta_headline: 'Your operation does not wait. Neither do we.',
  cta_subheadline: 'Get your supply quote in under 1 hour.',
  cta_button: 'Request 24/7 Quote',
  cta_footer_headline: 'Your port operation does not wait. Neither do we.',

  // Strategy
  strategy_tag: 'Multimodal Strategy',
  strategy_headline: 'End-to-end integrated operation at every port',
  strategy_subheadline: 'Four operational pillars that guarantee fleet continuity regardless of port, scale, or urgency.',
  strategy_logistica_title: 'Port Logistics',
  strategy_logistica_desc: 'Supply coordination across 13 strategic ports with owned fleet and real-time tracking of every delivery.',
  strategy_logistica_stat: 'Active Ports',
  strategy_logistica_highlight: 'Pacific and Gulf coverage',
  strategy_suministros_title: 'Critical Supplies',
  strategy_suministros_desc: 'Six certified supply lines: from fresh provisions to life-saving equipment and emergency pyrotechnics.',
  strategy_suministros_stat: 'Categories',
  strategy_suministros_highlight: 'Batch-audited quality',
  strategy_reparaciones_title: 'Naval Repairs',
  strategy_reparaciones_desc: 'Technical intervention in port with certified personnel. Preventive maintenance and urgent repairs without moving the vessel.',
  strategy_reparaciones_stat: 'Response time',
  strategy_reparaciones_highlight: 'Intervention without vessel movement',
  strategy_residuos_title: 'Waste Management',
  strategy_residuos_desc: 'Collection and disposal compliant with MARPOL, with complete documentation for port and environmental authorities.',
  strategy_residuos_stat: 'Regulatory compliance',
  strategy_residuos_highlight: 'Complete MARPOL documentation',

  // Ports
  ports_tag: 'National Presence',
  ports_headline: 'Operational coverage across Mexico\'s 13 strategic ports',
  ports_subheadline: 'From Manzanillo in the Pacific to Progreso in the Gulf of Mexico. Your fleet is never beyond our reach.',
  ports_pacific_title: 'Pacific Ocean',
  ports_gulf_title: 'Gulf of Mexico',

  // Certifications
  cert_247_title: '24/7 Operation',
  cert_247_desc: 'Personnel and fleet available any day of the year, including holidays and adverse weather conditions.',
  cert_iso_title: 'ISO Standards',
  cert_iso_desc: 'Documented quality processes and traceable supply chain with batch-by-batch control.',
  cert_safety_title: 'Industrial Safety',
  cert_safety_desc: 'Mandatory personal protective equipment, port safety protocols, and continuous training.',
  cert_response_title: 'Immediate Response',
  cert_response_desc: 'Average response time under 60 minutes for quotes and urgent dispatches.',

  // Gallery
  gallery_tag: 'Real Operations',
  gallery_headline: 'Infrastructure in Action',
  gallery_subheadline: 'Climate-controlled warehouses, certified waste management, and naval repair workshops. This is what we do daily.',
  gallery_tab_storage: 'Warehousing',
  gallery_tab_waste: 'Waste Collection',
  gallery_tab_repair: 'Boat Repair',

  // Map
  map_tag: 'National Coverage',
  map_headline: '13 Ports, 2 Coasts, 1 Operator',
  map_subheadline: 'From Manzanillo in the Pacific to Progreso in the Gulf. We make the difference at every port where your fleet docks.',
  map_popup_hub: 'Avimar Hub',

  // Footer
  footer_tagline: 'Port, maritime, and industrial solutions since 1975.',
  footer_description: 'Mexican multimodal company with presence in the country\'s 13 main ports.',
  footer_address: 'Calzada al Sumidero S/N, Industrial Zone, Coatzacoalcos, Veracruz, 96400, Mexico',
  footer_phone: 'Phone: +52 921 218 3400',
  footer_email: 'Email: contacto@avimarshipchandlers.com',
  footer_hours: 'Hours: 24 hours / 7 days',
  footer_nav_title: 'Navigation',
  footer_services_title: 'Services',
  footer_ports_title: 'Ports of Coverage',
  footer_ports_pacific: 'Pacific Ocean',
  footer_ports_gulf: 'Gulf of Mexico',
  footer_newsletter_title: 'Stay Informed',
  footer_newsletter_placeholder: 'Your email address',
  footer_newsletter_button: 'Subscribe',
  footer_newsletter_hint: 'Receive operational news and port coverage updates.',
  footer_copyright: '© 2026 Avimar Ship Chandlers. All rights reserved.',
  footer_privacy: 'Privacy Notice',
  footer_terms: 'Terms of Service',
  footer_brand_marquee: 'AVIMAR SHIP CHANDLERS',
};